import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IExamlistsubmitoverall } from "../../../Pages/Exam/IExam";

export const ListExamsubmitoverallSlice = createSlice({
  name: "ListExamsubmitoverallSlice",
  initialState: {} as IReduxState<IExamlistsubmitoverall[]>,
  reducers: {
    listExamsubmitoverall: (
      state,
      _: PayloadAction<IExamlistsubmitoverall>
    ) => {
      state.isLoading = true;
    },
    successlistExamsubmitoverall: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistExamsubmitoverall: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearListExamsubmitoverall: (state) => {
      state.data = {};
    },
  },
});

export const {
  failurelistExamsubmitoverall,
  listExamsubmitoverall,
  successlistExamsubmitoverall,
  clearListExamsubmitoverall,
} = ListExamsubmitoverallSlice.actions;

export default ListExamsubmitoverallSlice.reducer;
